export default "__VITE_PUBLIC_ASSET__26be223a__"